export const blockContactFieldStore = {
  columns: [
    { title: "Email", apiKeyName: "email", fieldInputType: "INPUT", isAction: false, isFixed: false },
    { title: "Phone", apiKeyName: "phone", fieldInputType: "INPUT", isAction: false, isFixed: false },
    { title: "Channel", apiKeyName: "channel", fieldInputType: "MULTI_OPT_OUT", isAction: false, isFixed: false },
    { title: "Actions", apiKeyName: "action", fieldInputType: "ACTION", isAction: true, isFixed: true, options: ["edit", "delete"] },
  ],
};
